export default __webpack_public_path__ + "static/media/Home.5aba6474.svg";